/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import toast from '@/services/toast';
import updatePpDetails from '../../update-paperpile-details';
import {
  bus
} from '@/main';
export default {
  name: 'upload-papers',
  components: {
    'update-pp-details' : updatePpDetails
  },
  props: ['uploadPaperFolderID'],
  data () {
    return {
      submitted:false,
      file:null,
      uploadAttachmentName:'',
      topic:'',
      updatePaperPileDetailPopupState:false,
      createPaperInfo:true,
      paperUpdateInfo:null,
      encryptedToggle:false,
      pdf_password:'',
      passwordIncorrectState:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('updatePaperPileDetailPopupStateBus', (data) => {
      this.updatePaperPileDetailPopupState = data;
    });

  },
  methods: {
    updatePpDetailMethod(data){
      this.paperUpdateInfo = data
      this.updatePaperPileDetailPopupState = true
      $('body').addClass('body_right_scroll_remove')  
    },
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
      this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', {id:this.uploadPaperFolderID})
    },
    handleAttachmentUpload(event) {
      var input = event.target;
      var reader = new FileReader();
      var _self = this
      reader.onload = function (event) {
          var contents = event.target.result;
          if (contents.indexOf('/Encrypt') !== -1) {
            _self.encryptedToggle = true
          } else {
            _self.encryptedToggle = false
          }
      };
      reader.readAsText(input.files[0]);
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }  else {
        this.uploadAttachmentName = '';
      }
    },
    createPaperpileBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('file', this.file);
          formData.append('title', this.topic);
          formData.append('file_name', this.uploadAttachmentName);
          formData.append('is_favourite', false);
          if(this.pdf_password != ''){
            formData.append('pdf_password', this.pdf_password);
          }
          this.$store.dispatch('createNewPaperPileFun', formData)
            .then((response) => {  
              this.file = null
              this.topic = ''
              this.$validator.reset()
                let payload = {
                  pdf_paper:response.data.data.id,
                  parent:this.uploadPaperFolderID,
                  is_folder:false
                }
                this.$store.dispatch('createBucketOfAwerackDetailsFun', payload).then((res) => {
                  toast.success(res.data.msg);
                  this.getPaperPileListAgain()
                  this.createPaperInfo = false
                  bus.$emit('paperSelectedBus', response.data.data.id);
                  this.updatePpDetailMethod(response.data.data);
                  this.submitted =  false
                })
            }).catch((err) => {
              if(err.status == '406'){
                this.submitted =  false
                toast.error('The pdf file already exists');
                bus.$emit('paperSelectedBus', err.data.data.id);
                this.closeCreatePaperpilePopup()
              }else if(err.status == '409'){
                this.passwordIncorrectState = true
                this.submitted =  false
                toast.error('PDF Password Incorrected');
              }else{
                this.submitted =  false
                toast.error(err.data.user_msg || err.data.msg);
              }
            })
          return;
        }
      })
    },
    closeCreatePaperpilePopup(){
      bus.$emit('uploadPaperStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
    keymonitor(){
      if( this.passwordIncorrectState == true){
        this.passwordIncorrectState = false
      }
    }
  }
}


